import { FC } from 'react';
import { Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { DateCellViewModel } from './viewModel';

type DateCellProps = GridRenderCellParams<DateCellViewModel>;

export const DateCell: FC<DateCellProps> = ({ value: viewModel }) => {
  return <Typography>{viewModel?.cellValue}</Typography>;
};
